import QRCodeStyling from 'qr-code-styling';
import { Space } from './Types/Space';

const [width, height] = [600, 800];
const [left, top] = [(window.innerWidth - width) / 2, (window.innerHeight - height) / 2];
const popUpOptions = `status=1,width=${width},height=${height},top=${top},left=${left}`;

const urlWithUtms = (source: any, lang: any) => {
  const url = new URL(window.location.href);

  url.searchParams.set('utm_source', source);
  url.searchParams.set('utm_medium', 'share');
  url.searchParams.set('utm_campaign', 'product');
  if (lang) {
    url.searchParams.set('lang', lang);
  }

  return url.href;
};

const buildUrl = (source: any, lang: any) => {
  return encodeURIComponent(urlWithUtms(source, lang));
};

export const shareFacebook = (lang?: string) => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${buildUrl('facebook', lang)}`,
    'Facebook share',
    popUpOptions,
  );
};

export const shareLinkedIn = (lang?: string) => {
  window.open(
    `https://www.linkedin.com/sharing/share-offsite/?url=${buildUrl('linkedin', lang)}`,
    'LinkedIn share',
    popUpOptions,
  );
};

export const shareX = (generateContent: any = null, lang?: string) => {
  const url = buildUrl('x', lang);
  const content = generateContent ? generateContent(url) : url;

  window.open(`https://twitter.com/intent/tweet?text=${content}`, 'X share', popUpOptions);
};

export const generateQrCode = (
  space: Space,
  { size = 300, lang = null, isBlackAndWhite = false },
) => {
  const dotsColor = isBlackAndWhite ? '#000' : space.custom_colors.primary_color;
  const cornerColor = isBlackAndWhite ? '#000' : space.custom_colors.secondary_color;

  const qrCode = new QRCodeStyling({
    width: size,
    height: size,
    backgroundOptions: {
      color: '#ffff',
    },
    dotsOptions: {
      type: 'rounded',
      color: dotsColor || undefined,
    },
    cornersSquareOptions: {
      color: cornerColor || undefined,
      type: 'extra-rounded',
    },
    imageOptions: {
      imageSize: 0.5,
      margin: 6,
    },
    data: urlWithUtms('qr', lang),
  });

  return qrCode;
};
